/**
 * isConverted — canonical check for whether a quote has been converted to a job.
 *
 * DEC-56 (2026-08-01): converted quotes are excluded from quote-listing surfaces,
 * not restyled inside them. A converted quote surfaces under the customer's Jobs
 * tab (the resulting job carries customer_id).
 *
 * A quote is converted if:
 *   - it has a `convertedJobId` or `converted_job_id` (the linked job's ID), OR
 *   - its `status` normalises to 'converted' (legacy records may use this string)
 *
 * Consumers (2, registered in COMPONENT_MAP.md):
 *   - QuotesPage (main listing filter)
 *   - CustomerDetail Quotes tab (filter)
 *
 * @param {object} q — quote record (from list or detail endpoint)
 * @returns {boolean}
 */
export function isConverted(q) {
  if (!q) return false;
  // IDI-222 (2026-09-03 ruling: "reporting keys off the job, status is not
  // touched"): a quote stuck at status="lost" but carrying a convertedJobId
  // genuinely converted, but this predicate must NOT treat it as "converted"
  // for listing-filter purposes -- doing so made these quotes vanish from
  // every surface that calls isConverted (QuotesPage, CustomerDetail Quotes
  // tab), not just miscounted. The ruling says status stays "lost"; this
  // predicate now agrees with that instead of overriding it.
  const s = (q.status || '').toLowerCase();
  if (s === 'lost') return false;
  if (q.convertedJobId || q.converted_job_id) return true;
  return s === 'converted';
}
